export default "__VITE_ASSET__5575e505__"